import { isEmpty } from 'lodash';

import { FrozenFieldsAfterPrefill } from 'api/api';

import { Context as BillingMachineContext } from '../state-machines/billing-flow-machine';
import { Context as RecipientMachineContext } from '../state-machines/recipient-flow-machine';
import { BillingFSMPayload, RecipientFSMPayload } from '../state-machines/shared-types';
import { isDeliveryAddressEmpty } from './prepare-address';

export const MODAL_STATES = [
  'modal.modalAddressList',
  'modal.modalAddressForm',
  'modal.extendedValidationModal',
] as const;

export type ModalStateNodes = (typeof MODAL_STATES)[number];

export const DELIVERY_ADDRESS_ARIA_TITLES = {
  'modal.modalAddressList': 'widget.aria.ADDRESS_BOOK_MODAL.TITLE',
  'modal.modalAddressForm': (
    machineContext: RecipientMachineContext | BillingMachineContext,
    frozenFields?: FrozenFieldsAfterPrefill['fields']
  ) => {
    if (machineContext.externalAddressBookProvider) {
      if (isEmpty(machineContext.currentAddress)) {
        return 'widget.delivery_address.ADD_DIFFERENT_ADDRESS'; // TODO
      } else if (machineContext.currentAddress?.is_dirty) {
        return 'widget.aria.ADDRESS_CONFIRMATION_MODAL.TITLE';
      } else {
        return 'widget.aria.EDIT_ADDRESS_MODAL.TITLE';
      }
    } else {
      if (isDeliveryAddressEmpty(machineContext.currentAddress || {}, frozenFields)) {
        return 'widget.delivery_address.ADD_DIFFERENT_ADDRESS'; // TODO
      } else {
        return 'widget.aria.EDIT_ADDRESS_MODAL.TITLE';
      }
    }
  },
  'modal.extendedValidationModal': 'widget.aria.ADDRESS_VALIDATION_MODAL.TITLE',
} as const;

export const BILLING_ADDRESS_ARIA_TITLES = {
  'modal.modalAddressList': 'widget.aria.BILLING_ADDRESS_BOOK_MODAL.TITLE',
  'modal.modalAddressForm': (
    machineContext: RecipientMachineContext | BillingMachineContext,
    frozenFields?: FrozenFieldsAfterPrefill['fields']
  ) => {
    if (machineContext.externalAddressBookProvider) {
      if (isEmpty(machineContext.currentAddress)) {
        return 'widget.delivery_address.ADD_DIFFERENT_ADDRESS';
      } else if (machineContext.currentAddress?.is_dirty) {
        return 'widget.aria.BILLING_ADDRESS_CONFIRMATION_MODAL.TITLE'; // TODO
      } else {
        return 'widget.aria.EDIT_ADDRESS_MODAL.TITLE';
      }
    } else {
      if (isDeliveryAddressEmpty(machineContext.currentAddress || {}, frozenFields)) {
        return 'widget.delivery_address.ADD_DIFFERENT_ADDRESS'; // TODO
      } else {
        return 'widget.aria.EDIT_ADDRESS_MODAL.TITLE';
      }
    }
  },
  'modal.extendedValidationModal': 'widget.aria.BILLING_ADDRESS_VALIDATION_MODAL.TITLE',
} as const;

export const getModalTitle = (
  machineContext: RecipientFSMPayload['context'] | BillingFSMPayload['context'],
  frozenFields?: FrozenFieldsAfterPrefill['fields']
) => {
  if (machineContext.externalAddressBookProvider) {
    if (isEmpty(machineContext.currentAddress)) {
      return 'widget.delivery_address.ADD_DIFFERENT_ADDRESS';
    } else if (machineContext.currentAddress?.is_dirty) {
      return 'widget.delivery_address.CONFIRM_ADDRESS';
    } else {
      return 'widget.delivery_address.EDIT_MODAL.TITLE';
    }
  } else {
    if (isDeliveryAddressEmpty(machineContext.currentAddress || {}, frozenFields)) {
      return 'widget.delivery_address.ADD_DIFFERENT_ADDRESS';
    } else {
      return 'widget.delivery_address.EDIT_MODAL.TITLE';
    }
  }
};
